import { IUpdateInspecaoObraOcorrenciaUseCase } from "../../../presentation/useCases/update/update_inspecao_obra_ocorrencia_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateInspecaoObraOcorrenciaUseCase
 */

export class UpdateInspecaoObraOcorrenciaUseCase implements IUpdateInspecaoObraOcorrenciaUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateInspecaoObraOcorrencia(
    idObra: number,
    idInspecaoObra: number,
    idInformacoesInspecaoObra: number,
    idItemInspecao: number | null,
    inspecao: number | null,
    descricao: string,
    dataDescricao: Date | null,
    tratativa: string | null,
    dataTratativa: Date | null,
  ): Promise<void> {
    await this.repository.updateInspecaoObraOcorrencia(
      idObra,
      idInspecaoObra,
      idInformacoesInspecaoObra,
      idItemInspecao,
      inspecao,
      descricao,
      dataDescricao,
      tratativa,
      dataTratativa,
    );
  }
}
